/**
 * author: omarg
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");



    var ZuoraIFrameSourceModel = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        ZuoraIFrameSourceModel = BaseModel.extend({

            resource: ApiResources.Registration.ZuoraIframeSource,
            name: "ZuoraIFrameSourceModel",
            defaults: {
                zuoraIFrameSource: ""
            }
        });
    });

    return ZuoraIFrameSourceModel;
});
